import React from 'react';
import './whatWeDo.scss';

export const WhatWeDo = () => {
  return (
    <div className="whatWeDo" id="whatWeDo">
      <h2>Co děláme</h2>
      <div className="whatWeDoItems">
        <div className="whatWeDoItem whatWeDoItem_blue">
          <h3>IT infrastruktura od návrhu až k realizaci</h3>
          <p>Pomůžeme Vám:</p>
          <ul>
            <li>Optimalizovat serverová řešení a oblast virtualizace</li>
            <li>Postavit privátní či hybridní cloud</li>{' '}
            <li>Zálohovat a archivovat Vaše data</li>
            <li>
              Vytvořit jednoduché síťové návrhy až po komplexní automatizovaná
              řešení
            </li>
          </ul>
        </div>
        <div className="whatWeDoItem">
          <h3>Bezpečnostní služby</h3>
          <p>
            Ať jsou Vaše data na Vaší infrastruktuře, v cloudu nebo se právě
            přenášejí po síti. Uvědomujeme si, že nebezpečí přichází z externího
            světa, ale je třeba věnovat pozornost i interním hrozbám.
          </p>
          <p>Aktivity směřujeme zejména do následujících oblastí:</p>
          <ul>
            <li>Zabezpečení firemní komunikace</li>
            <li>Zabezpečení webových a jiných aplikací</li>
            <li>Správa identit a přístupů</li>
            <li>Provozní testy bezpečnosti a bezpečnostní audity</li>
          </ul>
        </div>
      </div>
    </div>
  );
};
